import { render, staticRenderFns } from "./JobDashboard.vue?vue&type=template&id=f6bb2006&scoped=true&"
import script from "./JobDashboard.vue?vue&type=script&lang=js&"
export * from "./JobDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bb2006",
  null
  
)

export default component.exports